import _ from 'lodash'

class QuotationController {
    /** @ngInject */
    constructor($ngRedux, $scope, $window, DeviceChecker, ContractDraft, LandingPageLink) {
        this.isMobile = DeviceChecker.isMobile
        this.contractDraftService = ContractDraft

        /* ngRedux will merge the requested state's slice and actions onto this,
          you don't need to redefine them in your controller */
        const unsubscribe = $ngRedux.connect(this.mapStateToThis)(this)
        $scope.landingPageLink = `${LandingPageLink[$window.location.hostname]}/`
        $scope.$on('$destroy', unsubscribe)
    }

    $onChanges(changes) {
        if (changes.contractDraft) {
            this.onDispatch({ type: 'ON_CHANGES_CONTRACT_DRAFT', contractDraft: changes.contractDraft })
        }
        if (changes.landscapeQuestions) {
            this.onDispatch({ type: 'ON_CHANGES_LANDSCAPE_QUESTIONS', landscapeQuestions: changes.landscapeQuestions })
        }
        if (changes.tariffOptions) {
            this.onDispatch({ type: 'ON_CHANGES_TARIFF_OPTIONS', tariffOptions: changes.tariffOptions })
        }
        if (changes.viewState) {
            const viewState = changes.viewState.currentValue
            if (!_.isEmpty(viewState)) {
                this.onDispatch({ type: 'INIT_VIEW_STATE', viewState })
            }
        }
    }

    onDispatch(event) {
        // dispatch instantiated from $ngRedux.connect
        this.dispatch(event)
    }

   // Which part of the Redux global state does our component want to receive?
    mapStateToThis(state) {
        return {
            store: state.quotation,
        }
    }
}

export default {
    template: require('./quotation.jade')(),
    controller: QuotationController,
    bindings: {
        contractDraft: '<',
        landscapeQuestions: '<',
        tariffOptions: '<',
        viewState: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/quotation.js